
export default {
    props: {
        groupId: {
            type: Number,
            default: null,
        },
        groupSlug: {
            type: String,
            default: null,
        },
    },
    data () {
        return {
            loading: false,
            searchQuery: '',
            items: [],
            total: 0,
            expandedOpps: {},
            stats: {
                total_clients: null,
                clients_with_opportunities: null,
                clients_with_active_products: null,
                clients_with_upcoming_appointments: null,
            },
            form: {
                page: 1,
                size: 10,
                has_active_products: '',
                progress: '',
                appointment: '',
            },
            progressOptions: [
                { text: 'Progress: Any', value: '' },
                { text: 'Progress: Not yet started', value: 'Not yet started' },
                { text: 'Progress: Appointment scheduled', value: 'Appointment scheduled' },
                { text: 'Progress: In progress', value: 'In progress' },
                { text: 'Progress: Completed', value: 'Completed' },
                { text: 'Progress: Closed', value: 'Closed' },
            ],
            tableFields: [
                { key: 'name', label: 'Name', sortable: false },
                { key: 'dob', label: 'DOB', sortable: false },
                { key: 'email', label: 'Email', sortable: false },
                { key: 'cell_phone', label: 'Phone', sortable: false },
                { key: 'active_products', label: 'Active Products', sortable: false },
                { key: 'income_surcharges', label: 'Income Surcharges', sortable: false },
                { key: 'opportunities', label: 'Progress', sortable: false },
                { key: 'appointment', label: 'Upcoming Appointment', sortable: false },
            ],
        }
    },
    computed: {
        hasActiveFilters () {
            return !!(this.searchQuery || this.form.has_active_products || this.form.progress || this.form.appointment)
        },
    },
    watch: {
        searchQuery () {
            this.form.page = 1
            this.loadDashboard()
        },
        'form.page' () {
            this.loadDashboard()
        },
        'form.size' () {
            this.form.page = 1
            this.loadDashboard()
        },
        'form.has_active_products' () {
            this.form.page = 1
            this.loadDashboard()
        },
        'form.progress' () {
            this.form.page = 1
            this.loadDashboard()
        },
        'form.appointment' () {
            this.form.page = 1
            this.loadDashboard()
        },
        groupId () {
            this.loadDashboard()
        },
    },
    async mounted () {
        await this.loadDashboard()
    },
    methods: {
        async loadDashboard () {
            this.loading = true
            try {
                const res = await this.$api.getGroupDashboard({
                    query: this.searchQuery || undefined,
                    page: this.form.page,
                    size: this.form.size,
                    has_active_products: this.form.has_active_products || undefined,
                    progress: this.form.progress || undefined,
                    appointment: this.form.appointment || undefined,
                    group: this.groupId || undefined,
                })
                this.items = res.items || []
                this.total = res.total || 0
                this.stats = res.stats || this.stats
            } catch (e) {
                console.error('Failed to load dashboard:', e)
            }
            this.loading = false
        },
        displayName (item) {
            const first = item.preferred_name || item.first_name || ''
            const last = item.last_name || ''
            return `${first} ${last}`.trim()
        },
        planBadgeVariant (planType) {
            switch (planType) {
            case 'MAPD': return 'info'
            case 'SUPP': return 'warning'
            case 'PDP': return 'success'
            default: return 'secondary'
            }
        },
        stageBadgeVariant (stage) {
            if (!stage) return 'secondary'
            const s = stage.toLowerCase()
            if (s.includes('enrolled')) return 'success'
            if (s.includes('closed') && s.includes('won')) return 'success'
            if (s.includes('closed')) return 'danger'
            if (s.includes('quoted') || s.includes('proposal')) return 'info'
            return 'warning'
        },
        simpleProgressBadgeVariant (progress) {
            switch (progress) {
            case 'Completed': return 'success'
            case 'In progress': return 'warning'
            case 'Appointment scheduled': return 'info'
            case 'Closed': return 'danger'
            default: return 'secondary'
            }
        },
    },
}
